"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _CustomTblHeader = _interopRequireDefault(require("./header/CustomTblHeader"));
var _CustomPagination = _interopRequireDefault(require("./pagination/CustomPagination"));
var _CustomTblBody = _interopRequireDefault(require("./body/CustomTblBody"));
var _CustomToolbar = _interopRequireDefault(require("./toolbar/CustomToolbar"));
var _DisplayErrMsg = _interopRequireDefault(require("./errMsg/DisplayErrMsg"));
var _ExtendedView = _interopRequireDefault(require("./ExtendedView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var CustomTableContainer = function CustomTableContainer(props) {
  var children = props.children,
    customTheme = props.customTheme;
  var themeConfig = (0, _core.createTheme)({
    overrides: _objectSpread({}, customTheme)
  });
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: themeConfig
  }, /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    component: _core.Paper
  }, children));
};
var TableView = function TableView(_ref) {
  var _table$selectedRows, _table$selectedRows2;
  var _ref$tableRows = _ref.tableRows,
    tableRows = _ref$tableRows === void 0 ? [] : _ref$tableRows,
    table = _ref.table,
    onRowsPerPageChange = _ref.onRowsPerPageChange,
    onPageChange = _ref.onPageChange,
    onRowSelectChange = _ref.onRowSelectChange,
    onToggleSelectAll = _ref.onToggleSelectAll,
    totalRowCount = _ref.totalRowCount,
    onSortByColumn = _ref.onSortByColumn,
    onColumnViewChange = _ref.onColumnViewChange,
    _ref$themeConfig = _ref.themeConfig,
    themeConfig = _ref$themeConfig === void 0 ? {} : _ref$themeConfig;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ExtendedView.default, {
    table: table,
    onColumnViewChange: onColumnViewChange,
    onRowsPerPageChange: onRowsPerPageChange,
    onPageChange: onPageChange,
    numSelected: (table === null || table === void 0 ? void 0 : (_table$selectedRows = table.selectedRows) === null || _table$selectedRows === void 0 ? void 0 : _table$selectedRows.length) || 0,
    customTheme: themeConfig.extendedView
  }), /*#__PURE__*/_react.default.createElement(_CustomToolbar.default, {
    numSelected: (table === null || table === void 0 ? void 0 : (_table$selectedRows2 = table.selectedRows) === null || _table$selectedRows2 === void 0 ? void 0 : _table$selectedRows2.length) || 0,
    table: table,
    onColumnViewChange: onColumnViewChange,
    customTheme: themeConfig.toolbar
  }), /*#__PURE__*/_react.default.createElement(CustomTableContainer, {
    customTheme: themeConfig.tblContainer || {}
  }, /*#__PURE__*/_react.default.createElement(_core.Table, null, /*#__PURE__*/_react.default.createElement(_CustomTblHeader.default, {
    customTheme: themeConfig.tblHeader,
    table: table,
    rows: tableRows,
    count: totalRowCount,
    toggleSelectAll: onToggleSelectAll,
    sortByColumn: onSortByColumn
  }), /*#__PURE__*/_react.default.createElement(_CustomTblBody.default, {
    customTheme: themeConfig.tblBody,
    rows: tableRows,
    table: table,
    onRowSelectChange: onRowSelectChange
  }))), tableRows.length === 0 && /*#__PURE__*/_react.default.createElement(_DisplayErrMsg.default, {
    customTheme: themeConfig.displayErr,
    table: table
  }), /*#__PURE__*/_react.default.createElement(_CustomPagination.default, {
    customTheme: themeConfig.tblPgn,
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: table.totalRowCount || 0,
    rowsPerPage: table.rowsPerPage || 10,
    page: table.page || 0,
    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange
  }));
};
var _default = TableView;
exports.default = _default;